export default import.meta.ROLLDOWN_FILE_URL_wqWbEQawX3YD7lq5X8wRQw